// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f3d45c8f","455":"03c7f092","977":"10a58d1c"}[chunkId] + ".chunk.js";
};